var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// function getCartData() {
//   fetch('/cart.js', {
//     method: 'GET',
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
//   .then(response => {
//     if (!response.ok) {
//       throw new Error(`HTTP error! status: ${response.status}`);
//     }
//     return response.json();
//   })
//   .then(cart => {
//     // Handle the cart data
//     return cart;
//   });
// }

function updateCartElements(){
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  })
  .then(cart => {
    // Handle the cart data

    if (cart.item_count == 0){
      document.getElementById('cstm-shipping-bar').style.display = 'none';
    } else {
      document.getElementById('cstm-shipping-bar').style.display = 'block';
    }

    const freeShippingtarget = document.getElementById('cstm-shipping-bar').getAttribute('data-shipping-amount');
    const totalCartPrice = cart.total_price;
  
    let progressPercentage = totalCartPrice * 100 / freeShippingtarget;
    let remainingAmount = freeShippingtarget - totalCartPrice;
    if (remainingAmount <= 0){
      document.getElementById('completed-amount-msg').style.display = 'block';
      document.getElementById('remaining-amount-msg').style.display = 'none';
    }
    const remainingAmountFormatted = Shopify.formatMoney(remainingAmount, '{{amount}}');

    const dynRemaining = document.getElementById("remaining-amount");
    dynRemaining.textContent=remainingAmountFormatted;

    if (progressPercentage >= 100){
      progressPercentage = 100;
    }
  
    const barFill = document.getElementById("cstm-bar-fill");
    barFill.style.width = `${progressPercentage}%`;

    const savingElement = document.getElementById('cart-footer-data-save__value');
    const totalCartDiscount = cart.total_discount;
    const discountFooterLine = document.getElementById('cart-footer-data-line_save');
    const cstmCartDrawer = document.getElementById('cstm-cart-drawer');
    const cartCurrencySymbol = cstmCartDrawer.getAttribute('data-currency-symbol');
    const cartCurrencyIso = cstmCartDrawer.getAttribute('data-currency-iso');
    const formattedCartDiscount = Shopify.formatMoney(totalCartDiscount, cartCurrencySymbol + '{{amount}} ' + cartCurrencyIso);

    // Updating cart prices
    const cartItems = document.getElementsByClassName("cart-item");
    let totalSavings = 0;
    
    for (let i = 0; i < cartItems.length; i++) {
        const cartItem = cartItems[i];  
        const cartItemCAPTarget = cartItem.querySelectorAll(".cart-item__old-price")[1];
        const cartItemData = cart.items[i];
        const cartItemCAP = cartItem.getAttribute("data-compare-value");
        
        const cartItemTotalCAP = cartItemCAP * cartItemData.quantity;
        const cartItemTotalSavings = cartItemTotalCAP - cartItemData.line_price;
        
        totalSavings += cartItemTotalSavings; 
        
        const cartItemTotalCAPForm = Shopify.formatMoney(cartItemTotalCAP, cartCurrencySymbol + '{{amount}} ');
        const cartItemTotalSavingsForm = Shopify.formatMoney(cartItemTotalSavings, cartCurrencySymbol + '{{amount}} ' + cartCurrencyIso);
        
        cartItemCAPTarget.innerText = cartItemTotalCAPForm;
    }
    
    if (totalSavings > 0) {
        discountFooterLine.style.display = 'flex';
        savingElement.textContent = Shopify.formatMoney(totalSavings, cartCurrencySymbol + '{{amount}} ' + cartCurrencyIso);
    }
  });
}

document.addEventListener("DOMContentLoaded", (event) => {
  updateCartElements();
});

function observeCartDrawer(callback) {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) {
    console.warn('cart-drawer element not found');
    return;
  }

  let observer;
  let inactivityTimeout;

  const handleInactivity = () => {
    clearTimeout(inactivityTimeout);
    inactivityTimeout = setTimeout(() => {
      observer.disconnect();
      callback();
    }, 400); // Wait longer to ensure mutations have finished
  };

  observer = new MutationObserver((mutationsList) => {
    // Every mutation resets the timer
    handleInactivity();
  });

  observer.observe(cartDrawer, {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true,
  });

  // Kick off the first timer just in case
  handleInactivity();
}

subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  observeCartDrawer(() => {
    updateCartElements();
    setTimeout(() => {
      document.getElementById('cstm-cart-upsell-block').style.display = 'block';
      initCartUpsellSwiper();
    }, 300);
  });
});


subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
  const stickyCartImg = document.getElementById("cstm-sticky-atc-prod-image");
  stickyCartImg.src = event.data.variant.featured_image.src;
});

document.addEventListener("DOMContentLoaded", function() {
  const svgs = document.querySelectorAll('svg');
  
  svgs.forEach((svg, index) => {
    // Handle linear gradients
    const updateElementIds = (selector, attr) => {
      const elements = svg.querySelectorAll(selector);
      
      elements.forEach((element, gIndex) => {
        const newId = `pi-cstm-unique-${attr}${index}-${gIndex}`;
        const oldId = element.id;
        element.id = newId;
        
        // Update references to the old ID
        const references = svg.querySelectorAll(`[${attr}="url(#${oldId})"]`);
        references.forEach(ref => {
          ref.setAttribute(attr, `url(#${newId})`);
        });
      });
    };

    updateElementIds('linearGradient', 'fill');
    updateElementIds('linearGradient', 'stroke');
    updateElementIds('clipPath', 'clip-path');
  });
});










